import { Component, inject, Inject, OnInit } from '@angular/core';
import {
  AppliedFilter,
  FilterOption,
} from '../../block/fitlers/filters.component';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ContainerComponent } from '../../block/container/container.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { PageModel } from '../../../models/page.models';
import { PageService } from '../../../services/page.service';

@Component({
  selector: 'app-modal-filter',
  imports: [
    ContainerComponent,
    MatIconButton,
    MatIcon,
    MatFormField,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatDialogModule,
  ],
  templateUrl: './modal-filter.component.html',
  standalone: true,
  styleUrl: './modal-filter.component.scss',
})
export class ModalFilterComponent implements OnInit {
  private pageService = inject(PageService);
  page: PageModel = this.pageService.pages['general'];
  filterOptions: FilterOption[] = [];
  appliedFilters: AppliedFilter[] = [];

  ngOnInit() {
    console.log('Modal', this.page);
  }

  constructor(
    public dialogRef: MatDialogRef<ModalFilterComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      filterOptions: FilterOption[];
      appliedFilters: AppliedFilter[];
    },
  ) {
    this.filterOptions = data.filterOptions;
    this.appliedFilters = [...data.appliedFilters];
  }

  onFilterChange(filterId: string, event: any): void {
    const selectedValue = event.value;
    const filterOption = this.filterOptions.find(
      (option) => option.id === filterId,
    );

    if (!filterOption) return;

    this.appliedFilters = this.appliedFilters.filter(
      (f) => f.filterId !== filterId,
    );

    if (selectedValue) {
      const selectedOption = filterOption.options.find(
        (opt) => opt.value === selectedValue,
      );
      if (selectedOption) {
        this.appliedFilters.push({
          filterId: filterId,
          filterLabel: filterOption.label,
          value: selectedValue,
          label: selectedOption.label,
        });
      }
    }
  }

  getSelectedValue(filterId: string): string {
    const filter = this.appliedFilters.find((f) => f.filterId === filterId);
    return filter ? filter.value : '';
  }

  apply(): void {
    this.dialogRef.close(this.appliedFilters);
  }

  clear(): void {
    this.appliedFilters = [];
  }

  close(): void {
    this.dialogRef.close();
  }
}
